import { pageTitle } from 'ember-page-title';

<template>
  {{pageTitle "tcjr.org"}}

  {{outlet}}
</template>
